import { updateModalStateAction } from "./actions";

export function modalReducer(state = {}, action: any) {
    if (updateModalStateAction.is(action)) {
        return { ...state, ...{ [action.modalId]: action.newState } };
    }
    return state;
}
